import * as React from "react";
import {IMenuLinks} from "StateInterface";
import classnames from "classnames";

interface IProps {
    navExpand: boolean;
    textColor: string;
    textColorActive: string;
    onclick: (screen, flag) => void;
    links: IMenuLinks[];
    email: string;
    bgColor: string;
    flag: string;
}
const iconClassNames = {
    showGetStarted: "fa-check",
    showPersonalInfo: "fa-user-circle-o",
    showResidenceInfo: "fa-home",
    showEmploymentInfo: "fa-briefcase",
    showLoanAmountTenure: "fa-money",
    showReferences: "fa-users",
    showDocumentsInfo: "fa-file-text",
    showBankStatementInfo: "fa-bank",
}
export default class LeftPanel extends React.Component<IProps, {}> {
    public render() {
        const navClassName = classnames("add-padding nav col-12 collapse form-links", {show: this.props.navExpand});

        return (
            <nav className={navClassName} id="nav-form-links">
            {
                this.props.links.map((link, index) => {
                    return (
                        <a className="nav-link col-12 ml-sm-1"
                           key={index}
                            onClick={() => this.props.onclick(link.screen, link.flag)}
                            style={{fontSize: 17,
                                margin: "7px 0px 7px 7px",
                                backgroundColor: `${this.props.flag === link.flag ? "white" : "transparent"}`,
                                cursor: `${link.completed ? "pointer" : "auto"}`,
                                color: `${this.props.flag === link.flag ?
                                    this.props.textColorActive : this.props.textColor}`,
                                padding: ".6rem .5rem"}}
                            >
                            <i style={{color: `${this.props.flag === link.flag ?
                                    this.props.textColorActive : this.props.textColor}`}}
                               className={` mr-2 fa ${iconClassNames[link.flag]}`}></i>
                            {link.title}&nbsp;
                            {link.completed &&
                                <span>
                                    <i className="fa fa-check-circle"
                                       style={{color: `${this.props.flag === link.flag ?
                                        this.props.textColorActive : this.props.textColor}`, margin: "4px 0px 0px 0px",
                                        float: "right"}}
                                    >
                                    </i>
                                </span>
                            }
                    </a>);
                })
            }
            <br/><br/>
        </nav>
        );
    }
}
